<template>
    <component :is="layout"></component>
</template>

<script>
  import Vue from 'vue';

  const DEFAULT_TEMPLATE = 'default';

  export default {
    data() {
      return {
        template: DEFAULT_TEMPLATE,
        layout: null,
      };
    },
    computed: {
      loader() {
        Vue.component('coupon-banner', require(`./templates/${this.template}/components/CouponBanner.vue`).default);
        Vue.component('hidden-album-form',
            require(`./templates/${this.template}/components/HiddenAlbumForm.vue`).default);
        Vue.component('coupon', require(`./templates/${this.template}/components/Coupon.vue`).default);

        return () => import(`./templates/${this.template}`);
      },
    },
    methods: {
      changeFavicon() {
        const link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link');
        link.type = this.coreParams.shop_asset_image.favicon_content_type;
        link.rel = 'shortcut icon';
        link.href = this.coreParams.shop_asset_image.favicon_original;
        document.getElementsByTagName('head')[0].appendChild(link);
      },
    },
    async created() {
      await this.$store.dispatch('SET_CORE_PARAMS');

      if (this.coreParams) {
        this.template = this.getTemplateName();

        if (this.coreParams.shop_asset_image
            && this.coreParams.shop_asset_image.favicon_content_type
            && this.coreParams.shop_asset_image.favicon_original)
          this.changeFavicon();
      }

      this.loader().then(() => {
        this.layout = () => this.loader();
      }).catch(() => {
        this.layout = () => {
          import(`./templates/${DEFAULT_TEMPLATE}`);
        };
      });
    },
    mounted() {
      if (this.isMobile) {
        document.body.classList.add('-is-mobile');

        document.addEventListener('gesturestart', function(e) {
          e.preventDefault();
        });

        document.addEventListener('touchmove', function(e) {
          e = e.originalEvent || e;

          if (e.scale > 1) {
            e.preventDefault();
          }
        }, false);
      }
    },
  };
</script>
